import FormBuilderConfig from "../../../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import ITextBuilder from "../../../../../toolkit/baseForms2/iTextBuilder/ITextBuilder";
import {
  formatMoney,
  formatNumber,
  formatPercent
} from "../../../../helpers/formatters";
import { userHasPermission } from "../../../../../utils/accessTree";
import permissionCodes from "../../../../../utils/permissionCodes";

const {
  TRACKING_VENTAS_MEMBRESIA_EDICION_COMPROMISOS_PERIODO: EDICION_COMPROMISOS_PERIODO
} = permissionCodes;

export type Inputs =
  | "consolidadoPresupuesto"
  | "consolidadoCompromiso"
  | "consolidadoActual"
  | "consolidadoAlcance"
  | "totalVentasPresupuesto"
  | "totalVentasCompromiso"
  | "totalVentasActual"
  | "totalVentasAlcance"
  | "numeroProspectosPresupuesto"
  | "numeroProspectosCompromiso"
  | "numeroProspectosActual"
  | "numeroProspectosAlcance";

export type Buttons = never;

export const formConfigMapper: (
  periodoAnterior,
  plantillaConfirmada
) => FormBuilderConfig<Inputs, Buttons> = (
  periodoAnterior,
  plantillaConfirmada
) => ({
  inputs: [
    {
      name: "consolidadoPresupuesto",
      label: "",
      component: ITextBuilder,
      props: {
        type: "NUMERIC",
        cellCollapsed: true,
        cellFormatter: value => formatNumber(Number(value)),
        disabled: true
      }
    },
    {
      name: "consolidadoCompromiso",
      label: "",
      component: ITextBuilder,
      props: {
        type: "NUMERIC",
        cellCollapsed: true,
        cellFormatter: value => formatNumber(Number(value)),
        disabled:
          periodoAnterior ||
          plantillaConfirmada ||
          !userHasPermission(EDICION_COMPROMISOS_PERIODO)
      }
    },
    {
      name: "consolidadoActual",
      label: "",
      component: ITextBuilder,
      props: {
        type: "NUMERIC",
        cellCollapsed: true,
        cellFormatter: value => formatNumber(Number(value)),
        disabled: true
      }
    },
    {
      name: "consolidadoAlcance",
      label: "",
      component: ITextBuilder,
      props: {
        type: "NUMERIC",
        cellCollapsed: true,
        cellFormatter: value => formatPercent(Number(value)),
        disabled: true
      }
    },
    {
      name: "totalVentasPresupuesto",
      label: "",
      component: ITextBuilder,
      props: {
        type: "NUMERIC",
        cellCollapsed: true,
        cellFormatter: value => formatMoney(Number(value), 2),
        disabled: true
      }
    },
    {
      name: "totalVentasCompromiso",
      label: "",
      component: ITextBuilder,
      props: {
        type: "NUMERIC",
        cellCollapsed: true,
        cellFormatter: value => formatMoney(Number(value), 2),
        disabled:
          periodoAnterior || !userHasPermission(EDICION_COMPROMISOS_PERIODO)
      }
    },
    {
      name: "totalVentasActual",
      label: "",
      component: ITextBuilder,
      props: {
        type: "NUMERIC",
        cellCollapsed: true,
        cellFormatter: value => formatMoney(Number(value), 2),
        disabled: true
      }
    },
    {
      name: "totalVentasAlcance",
      label: "",
      component: ITextBuilder,
      props: {
        type: "NUMERIC",
        cellCollapsed: true,
        cellFormatter: value => formatPercent(Number(value)),
        disabled: true
      }
    },
    {
      name: "numeroProspectosPresupuesto",
      label: "",
      component: ITextBuilder,
      props: {
        type: "NUMERIC",
        cellCollapsed: true,
        cellFormatter: value => formatNumber(Number(value)),
        disabled: true
      }
    },
    {
      name: "numeroProspectosCompromiso",
      label: "",
      component: ITextBuilder,
      props: {
        type: "NUMERIC",
        cellCollapsed: true,
        cellFormatter: value => formatNumber(Number(value)),
        disabled:
          periodoAnterior || !userHasPermission(EDICION_COMPROMISOS_PERIODO)
      }
    },
    {
      name: "numeroProspectosActual",
      label: "",
      component: ITextBuilder,
      props: {
        type: "NUMERIC",
        cellCollapsed: true,
        cellFormatter: value => formatNumber(Number(value)),
        disabled: true
      }
    },
    {
      name: "numeroProspectosAlcance",
      label: "",
      component: ITextBuilder,
      props: {
        type: "NUMERIC",
        cellCollapsed: true,
        cellFormatter: value => formatPercent(Number(value)),
        disabled: true
      }
    }
  ],
  buttons: [],
  validations: {
    consolidadoCompromiso: {
      minNumber: {
        validator: value => value && Number(value) < 0,
        message: () => "Debe ser mayor o igual a 0"
      }
    },
    totalVentasCompromiso: {
      minNumber: {
        validator: value => value && Number(value) < 0,
        message: () => "Debe ser mayor o igual a 0"
      }
    },
    numeroProspectosCompromiso: {
      minNumber: {
        validator: value => value && Number(value) < 0,
        message: () => "Debe ser mayor o igual a 0"
      }
    }
  },
  rows: [
    [
      "consolidadoPresupuesto",
      "consolidadoCompromiso",
      "consolidadoActual",
      "consolidadoAlcance",
      "totalVentasPresupuesto",
      "totalVentasCompromiso",
      "totalVentasActual",
      "totalVentasAlcance",
      "numeroProspectosPresupuesto",
      "numeroProspectosCompromiso",
      "numeroProspectosActual",
      "numeroProspectosAlcance"
    ]
  ]
});
